const PaymentMethodEnum = Object.freeze({
    WALLET: "WALLET",
    CREDIT_CARD: "CREDIT_CARD",
    POST_PAID: "POST_PAID",
    SAVED_CC: "SAVED_CC",
    BANK_TRANSFER: "BANK_TRANSFER",
    PAYNOW: "PAYNOW",
  });

  export default PaymentMethodEnum;
